(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/number-selector/assets/javascripts/number-selector-input.js') >= 0) return;  svs.modules.push('/components/lb-ui/number-selector/assets/javascripts/number-selector-input.js');
"use strict";

const NumberSelectorInput = _ref => {
  let classname = _ref.classname,
    maxValue = _ref.maxValue,
    minValue = _ref.minValue,
    onInputBlur = _ref.onInputBlur,
    onInputChange = _ref.onInputChange,
    onInputFocus = _ref.onInputFocus,
    onInputKeyDown = _ref.onInputKeyDown,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    value = _ref.value;
  const classNames = ['number-selector-input'];
  if (classname) {
    classNames.push(classname);
  }
  prefix = prefix || '';
  suffix = suffix || '';
  const inputValue = "".concat(prefix).concat(value).concat(suffix);
  return React.createElement("input", {
    "aria-label": "V\xE4rde",
    className: "".concat(classNames.join(' ')),
    max: maxValue,
    min: minValue,
    onBlur: onInputBlur,
    onChange: onInputChange,
    onFocus: onInputFocus,
    onKeyDown: onInputKeyDown,
    type: "number",
    value: inputValue
  });
};
setGlobal('svs.components.lbUi.numberSelector.NumberSelectorInput', NumberSelectorInput);

 })(window);